import { useQuery } from "@tanstack/react-query";

import { apiClient, getQueryKey } from "app/modules/api-client";
import { RESOURCE_NOT_FOUND_TYPE, ResponseError } from "app/services/fetchService";

import { getSecondaryListClaims } from "../utils/getSecondaryListClaims";
import { useAlertsParams } from "./useAlertsParams";

export const useSecondaryDomains = () => {
    const { activationId } = useAlertsParams();
    const { isEnabled } = getSecondaryListClaims();

    const { data, isLoading } = useQuery({
        queryKey: getQueryKey({
            tag: "Alerts",
            methodName: "userdataActivationAlertsSecondaryDomainsDetail",
            args: [activationId],
        }),
        queryFn: async () => {
            try {
                return await apiClient.Alerts.userdataActivationAlertsSecondaryDomainsDetail(activationId);
            } catch (error) {
                if (
                    error instanceof ResponseError &&
                    error.status === 404 &&
                    error.problem?.type === RESOURCE_NOT_FOUND_TYPE
                ) {
                    return null;
                }

                throw error;
            }
        },
        enabled: isEnabled,
    });

    return {
        domains: data?.domains ?? [],
        isLoading: isEnabled ? isLoading : false,
    };
};
